import { FaSearchPlus } from 'react-icons/fa';

const Gallery = ({galleries, isSetObj, isSetModal}) => {

      if(galleries.data) return;

      const getItem = (item) => {
            isSetObj(item);
            isSetModal(true);
      }

      return (
            <div className="container gallery">
                  {
                        galleries.map((item, index) => (
                              <div className="card_gallery" key={index}>
                                    <div className="card_image">
                                          <img src={item.image} alt={item.description} />
                                    </div>
                                    <div className="footer_card">
                                          <span>{item.description}</span>
                                    </div>
                                    <button className="btn_gallery" onClick={() => getItem(item)}><FaSearchPlus /></button>
                              </div>
                        ))
                  }
                  
            </div>
      )
}

export default Gallery;